// extracted by mini-css-extract-plugin
module.exports = {"power-preparedness-R":"R_power-preparedness-R__0_8gl"};